<script setup>
import { ref,onMounted, watch,computed ,reactive } from 'vue'
import { useRoute,useRouter } from 'vue-router';
import { productOfferService } from "@/services/productOfferService";
import ProductsTable from "./components/ProductsTable.vue";
//import LoadingBar from '@/views/components/common/LoadingBar.vue';
import ArgonButton from "@/components/ArgonButton.vue";


const route = useRoute();
const router = useRouter();

const isLoading = ref(false);

//-----------------------------------

const totalCount = ref(0);
const totalPages = ref(1)
const initialized = ref(false);

async function onSortChanged({ field, desc }) {
    searchCriteria.sortBy = field;
    searchCriteria.sortDesc = desc;
}

const searchCriteria = reactive({
    productId:0,
    categoryId: 0,
    searchText: '',
    page: 1,
    pageSize: 25,
    sortBy: 'UpdatedOnUtc',
    sortDesc: true
});

const filters = computed(() => ({
    filters: [
        {
            field: 'ProductName',
            operator: 'contains',
            value: searchCriteria.searchText
        },
        {
            field: 'CategoryId',
            operator: 'eq',
            value: searchCriteria.categoryId.toString()
        },
        {
            field: 'ProductId',
            operator: 'eq',
            value: searchCriteria.productId.toString()
        }
    ],
    sorts: [
            {
                field: searchCriteria.sortBy,
                descending: searchCriteria.sortDesc
            }
        ],
    page: searchCriteria.page,
    pageSize: searchCriteria.pageSize
}));

const Products = ref();
const Categories = ref();

onMounted(async () => {
  console.log(route.query);
    
  await loadCategories()
    
  initialized.value = true;

})

watch(() => ({ ...searchCriteria }),async (newValues,oldValues) => {

      console.log('watch searchCriteria','initialized.value',initialized.value,'old',oldValues,'->','new',newValues)
      
      if (!initialized.value)
            return;

        if (searchCriteria.searchText.length > 0 && searchCriteria.searchText.length < 3) {
            return;
        }
        
        const resetPage = ['categoryId', 'productId', 'searchText','sortBy','sortDesc','pageSize'].some(key => newValues[key] !== oldValues[key]);

        if (resetPage) {
            searchCriteria.page = 1;
        }

        router.replace({
            query: Object.fromEntries(
                Object.entries(searchCriteria).map(([key, value]) => [key, String(value)])
            )
        }); 

        await loadProducts();
    }
);

watch(() => route.query,async (newQuery,oldQuery) => {
    
    console.log('watch url','initialized.value',initialized.value, oldQuery,'->',newQuery)
        
    for (const key of Object.keys(searchCriteria)) {

        if (!(key in newQuery))
            continue;

        const defaultValue = searchCriteria[key];

        if (typeof defaultValue === 'number') {
            searchCriteria[key] = Number(newQuery[key]);
        }
        else if (typeof defaultValue === 'boolean') {
            searchCriteria[key] = newQuery[key] === 'true';
        }
        else {
            searchCriteria[key] = newQuery[key];
        }
    }


    if (!initialized.value)      
      await loadProducts();

  },
  { immediate: true }
);

async function loadProducts() {
  console.log(filters.value)
  try{
    isLoading.value = true;
    const response = await productOfferService.getProductsBySearchRequest(filters.value);
    if (response.data?.Success) {
      console.log(">>>>>>>>>>>>Response Data:",response.data.Data)
      
      Products.value = response.data.Data.Items;
      
      totalCount.value = response.data.Data.TotalCount;
      totalPages.value = response.data.Data.TotalPages;
    }
  }catch(error)
  {
    console.error(error);
  }
  finally{
    isLoading.value=false;
  }
}

async function loadCategories() {
  try{
    isLoading.value = true;
    const response = await productOfferService.getCategories(true);
    if (response.data?.Success) {
        Categories.value = response.data.Data;
    }
  }catch(error)
  {
    console.error(error);
  }
  finally{
    isLoading.value=false;
  }  
}


</script>
<template>

    <div class="card m-4">

      <!-- Header -->
      <div class="card-header pb-0">
          <div class="d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                  Wyszukiwanie produktów
              </h6>

              <argon-button
                  color="dark"
                  variant="gradient"
                  size="sm"
                  @click="loadProducts()"
              >
                  <i class="fas fa-search me-2"></i>
                  Filtruj
              </argon-button>
          </div>
      </div>

      <!-- Body -->
      <div class="card-body">

          <div class="row g-3 align-items-end">
            <!-- Nazwa -->
            <div class="col-lg-5">

                <label class="form-label">
                    Nazwa produktu
                </label>

                <input
                    v-model="searchCriteria.searchText"
                    class="form-control"
                    placeholder="Wpisz nazwę produktu..."
                />

            </div>
            <!-- Kategoria -->
            <div class="col-lg-5">

                <label class="form-label">
                    Kategoria
                </label>

                <select
                    v-model.number="searchCriteria.categoryId"
                    class="form-select"
                >
                    <option :value="0">
                        -- Wszystkie --
                    </option>

                    <option
                        v-for="category in Categories"
                        :key="category.Id"
                        :value="category.Id"
                    >
                        {{ category.Path }}
                    </option>

                </select>

            </div>

            

            <!-- Button -->
            <div class="col-lg-2 d-grid">

                <argon-button
                    color="dark"
                    variant="gradient"
                    @click="loadProducts()"
                >
                    <i class="fas fa-search me-2"></i>
                    Szukaj
                </argon-button>

            </div>

          </div>

      </div>

      <!-- Footer -->
      <div class="card-footer">

          <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">

              <div>

                  <button
                      class="btn btn-outline-secondary btn-sm me-2"
                      :disabled="searchCriteria.page <= 1"
                      @click="searchCriteria.page--"
                  >
                      <i class="fas fa-chevron-left"></i>
                      Poprzednia
                  </button>

                  <button
                      class="btn btn-outline-secondary btn-sm"
                      :disabled="searchCriteria.page >= totalPages"
                      @click="searchCriteria.page++"
                  >
                      Następna
                      <i class="fas fa-chevron-right"></i>
                  </button>

              </div>

              <div class="fw-bold">

                  Strona {{ searchCriteria.page }}
                  z {{ totalPages }}

                  <span class="text-muted ms-2">
                      ({{ totalCount }} produktów)
                  </span>

              </div>

              <div class="d-flex align-items-center">

                  <span class="me-2">
                      Na stronę:
                  </span>

                  <select
                      v-model="searchCriteria.pageSize"
                      class="form-select"
                      style="width:100px"
                  >
                      <option :value="10">10</option>
                      <option :value="25">25</option>
                      <option :value="50">50</option>
                      <option :value="100">100</option>
                  </select>

              </div>

          </div>

      </div>

    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <products-table :products="Products" :is-loading="isLoading"  @sort-changed="onSortChanged" :sort-by="searchCriteria.sortBy" :sort-desc="searchCriteria.sortDesc" />
        </div>
      </div>
    </div>
</template>
